import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Platform } from '@ionic/angular/lazy';
import { Router } from '@angular/router';
import { LangProvider } from './services/lang/lang';
import { SpiaggiaService } from './services/utils/spiaggia.service';
import { AuthGuardService } from './services/auth-guard.service';
import { SplashScreen } from '@capacitor/splash-screen';
import { HttprequestService } from './services/httprequest.service';
import { StorageService } from './services/storage-service.service';
import { serviziRest } from 'src/environments/environment';
import { AlertService } from './services/alert-service.service';
import { UserService } from './services/utils/user.service';
import { register } from 'swiper/element/bundle';
import { firstValueFrom } from 'rxjs';

register();

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AppComponent {
  isServerStatusDown: boolean = false;
  tokenValue: boolean = false; //qui verifico il token dell'utente: se ok, manda ai servizi altrimenti alla login
  platformOs: string = "";


  constructor(
    private router: Router,
    private platform: Platform,
    private lingua: LangProvider,
    private myService: SpiaggiaService,
    private userService: UserService,
    private httpService: HttprequestService,
    private alertService: AlertService,
    private storage: StorageService,
    private authGuardService: AuthGuardService,
  ) {
    SplashScreen.show();
    this.checkServerStatus();
  }

  async checkServerStatus() {
    this.isServerStatusDown = false;
    await this.platform.ready();

    try {
      const res = await firstValueFrom(
        this.httpService.doGetTimeout(serviziRest.checkAppInManutenzione)
      );

      SplashScreen.hide();

      if (res != null && res != undefined) {
        if (res == 1) {
          this.myService.appInManutenzione = true;
          this.isServerStatusDown = true;
          this.alertService.alertAppInManutenzione();
        } else {
          this.myService.appInManutenzione = false;
          this.isServerStatusDown = false;
          this.initializeApp();
        }
      }
    } catch (error) {
      console.log(error);
      SplashScreen.hide();
    }
  }


  initializeApp() {
    this.checkFirstSteps();
  }




  checkFirstSteps() {
    this.storage.get('locale_lang').then((res => {
      if (res != undefined && res != null && res != '') {
        this.lingua.languageSelected = res;
      }
      else {
        this.storage.set('locale_lang', 'IT');
        this.lingua.languageSelected = 'IT';
      }

      this.userService.checkAppPlatform();
      this.checkLastStepsAndStart();
      this.checkFunzioniDisponibili();
    }));
  }

  checkFunzioniDisponibili() {
    this.myService.checkSocialLogin();
    this.myService.getLimiteOrarioPrenotazione();
  }

  checkLastStepsAndStart() {


    this.myService.isVersionObsoleta = false;
    this.storage.get('token').then((res => {
      if (res != undefined && res != null && res != '') {
        this.userService.isUserLoggedIn = true;
        this.storage.get('username').then((res => {
          this.userService.getDatiUtente(res, '');
        }));
        this.myService.checkPopOver();
        // this.router.navigate(['/mainpage']);
        this.authGuardService.canActivate();
      }
      else {
        this.userService.isUserLoggedIn = false;
        this.router.navigate(['/welcome']);
        this.authGuardService.canActivate();
      }
    }));
  }


  logout() {

    this.userService.isUserLoggedIn = false;
    this.storage.set('token', '');
    this.storage.set('tutorialCompleted', '');
    this.storage.set('tokenPush', '');
    this.storage.set('username', '');
    this.storage.set('showModale', '');
    this.storage.set('showModaleGenerica', '');
    this.storage.set('dataCookieGenerico', '');
    this.router.navigate(['/welcome']);
  }

}
